import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext } from '@tanstack/react-router';

import { AppShell } from '@/components/AppShell';
import { I18nAppProvider, useI18n } from '@/lib/i18n';

export interface RouterAppContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterAppContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  return (
    <I18nAppProvider>
      <AppShell />
    </I18nAppProvider>
  );
}

function NotFoundComponent() {
  return (
    <I18nAppProvider>
      <NotFoundContent />
    </I18nAppProvider>
  );
}

function NotFoundContent() {
  const { t } = useI18n();

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center gap-3 px-4 text-center">
      <p className="text-sm font-medium uppercase tracking-wider text-muted-foreground">404</p>
      <h1 className="text-3xl font-semibold tracking-tight text-foreground">{t('notFound.title')}</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        {t('notFound.description')}
      </p>
    </div>
  );
}
